import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-exit-confirmation',
    templateUrl: './exit-confirmation.component.html',
    styleUrls: ['./exit-confirmation.component.css'],
    standalone: false
})
export class ExitConfirmationComponent implements OnInit {
  patient: any;
  gid: string;
  errorLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private PatientsService: PatientsService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.gid = params['g'];
      const pid = params['p'];

      if (!this.gid || !pid) {
        this.errorLoading = true;
        return;
      }

      this.PatientsService.getPatientByPID(pid, this.gid, (status) => {
        if (!status) {
          this.errorLoading = true;
          return;
        }
        this.patient = this.PatientsService.currentPatient;
      });
    });
  }

  goHome(): void {
    // Navigate back to home or main page
    this.router.navigate(['/']);
  }
}
